export default {
    'requestTime': 5000, //请求时间
    'carousel': 5000 //轮播时间
}